import { toSpecialFixed } from '@/lib/misc/utils';
import { useEffect, useState } from 'react';
export default function useSpecialFixDecimals(_a) {
    var assets = _a.assets;
    //used for fixing decimal number for user amounts for good UX
    var _b = useState([]), specialFixDecimals = _b[0], setSpecialFixDecimals = _b[1];
    useEffect(function () {
        if (!assets || !(assets === null || assets === void 0 ? void 0 : assets[0])) {
            return;
        }
        setSpecialFixDecimals(function (prev) {
            return assets === null || assets === void 0 ? void 0 : assets.map(function (item) {
                var _a, _b;
                var key = (item === null || item === void 0 ? void 0 : item.contract_address) + (item === null || item === void 0 ? void 0 : item.network);
                var decimals;
                decimals =
                    ((_a = prev.find(function (x) { return x.key == key; })) === null || _a === void 0 ? void 0 : _a.decimals) ||
                        ((_b = toSpecialFixed(item === null || item === void 0 ? void 0 : item.formatted_balance)) === null || _b === void 0 ? void 0 : _b.numDecimals);
                return {
                    key: key,
                    decimals: decimals,
                };
            });
        });
    }, [assets]);
    return {
        specialFixDecimals: specialFixDecimals,
        setSpecialFixDecimals: setSpecialFixDecimals,
    };
}
export function getSpecialFixDecimals(assetItem, specialFixDecimals) {
    var _a;
    return (_a = specialFixDecimals === null || specialFixDecimals === void 0 ? void 0 : specialFixDecimals.find(function (x) { return x.key == (assetItem === null || assetItem === void 0 ? void 0 : assetItem.contract_address) + (assetItem === null || assetItem === void 0 ? void 0 : assetItem.network); })) === null || _a === void 0 ? void 0 : _a.decimals;
}
